import React from 'react';
import {FormHeading} from '../../form';
import { IStepProps } from './types';

export const Step: React.FC<IStepProps> = ({
  heading,
  subHeading,
  children,
}) => (
  <div>
    <FormHeading title={heading || ''} subTitle={subHeading} />
    {children}
  </div>
);
